export default "__VITE_ASSET__Bx301EQr__"